<div class="col-md-12 ml-auto mr-auto">
  <div id="card-dashboard" class="card" style="height: 1500px">
    <div class="card-dashboard"></div>
  </div>
</div>
